/**
 * Parameters for creating a SAP maintenance notification
 */
export type CreateMaintenanceNotification = {
  sourceEventId: string
  workCenterId?: string
  plannerGroupId?: string
  /** IDs of existing event attachments to include with the SAP notification */
  attachmentIds?: number[]
}

/**
 * Infor department codes for work order requests
 */
export enum InforDepartmentCode {
  Electrical = 'electrical',
  Garage = 'garage',
  Hse = 'hse',
  Laboratory = 'laboratory',
  Logistic = 'logistic',
  Maintenance = 'maintenance',
  Mcc = 'mcc',
  Mechanical = 'mechanical',
  Process = 'process',
  Production = 'production',
  Project = 'project',
  Quarry = 'quarry',
  Warehouse = 'warehouse'
}

/**
 * Infor priority levels for work order requests
 */
export enum InforPriority {
  Immediate = 'immediate',
  WithinADay = 'withinADay',
  WithinOneWeek = 'withinOneWeek',
  WithinOneMonth = 'withinOneMonth',
  NextPmStop = 'nextPmStop',
  AnnualShutdown = 'annualShutdown',
  BufferWork = 'bufferWork'
}

/**
 * Infor problem codes for work order requests
 */
export enum InforProblemCode {
  Alarm = 'alarm',
  BeltConveyorFault = 'beltConveyorFault',
  ElevatorFault = 'elevatorFault',
  PlannedRepairWork = 'plannedRepairWork',
  CompressedAirFault = 'compressedAirFault',
  DedustingFaultyDPFT = 'dedustingFaultyDPFT',
  FillingFailure = 'fillingFailure',
  FluxoPumpFailure = 'fluxoPumpFailure',
  GateValveFault = 'gateValveFault',
  HighTemperatureHTMP = 'highTemperatureHTMP',
  ExcessiveVibrationHv = 'excessiveVibrationHv',
  EquipmentJammed = 'equipmentJammed',
  KilnInDefault = 'kilnInDefault',
  Leakage = 'leakage',
  Miscellaneous = 'miscellaneous',
  PanConvDefault = 'panConvDefault',
  LinerPlateFault = 'linerPlateFault',
  RoutineInspectionMonitoring = 'routineInspectionMonitoring',
  RoutineLubrication = 'routineLubrication',
  RoutinePreventativeMaintenance = 'routinePreventativeMaintenance',
  ReclaimerDefault = 'reclaimerDefault',
  RefractoryFault = 'refractoryFault',
  RollerMillFault = 'rollerMillFault',
  RunningFailure = 'runningFailure',
  EquipmentSeizure = 'equipmentSeizure',
  StartingFailure = 'startingFailure',
  EquipmentTripped = 'equipmentTripped'
}

/**
 * Parameters for creating an Infor work order request
 */
export type CreateInforWorkOrderRequest = {
  eventId: string
  equipmentTechnicalId: string
  priority: InforPriority
  problemCode: InforProblemCode
  departmentCode: InforDepartmentCode
}

/**
 * Planner group for maintenance notifications
 */
export type PlannerGroup = {
  plannerGroupId: string
  plannerGroupName: string
}
